import * as types from './mutation-types'
import {
  resetForfaitTransport
} from '../../../api/forfaitTransport'
import {
  getTypeForfaitTransport,
  postTypeForfaitTransport
} from '../../../api/typeForfaitTransport'
import * as constants from '../modal/modal-constants'

const getInitialState = () => {
  return {
    typeForfaitTransport: null
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.INIT_TYPE_FORFAIT_TRANSPORT](state, typeForfaitTransport) {
    state.typeForfaitTransport = {
      ...state.typeForfaitTransport = typeForfaitTransport
    }
  },
  [types.SET_TYPE_FORFAIT_TRANSPORT](state, typeForfaitTransport) {
    state.typeForfaitTransport = {
      ...state.typeForfaitTransport,
      ['typeForfait']: typeForfaitTransport
    }
  }
}

const actions = {
    async initTypeForfaitTransport({ state, commit }) {
    const typeForfait = await getTypeForfaitTransport()
    commit(types.INIT_TYPE_FORFAIT_TRANSPORT, typeForfait)
  },
  async setTypeForfait({ commit }, typeForfait) {
    commit(types.SET_TYPE_FORFAIT_TRANSPORT, typeForfait)
  },
  async updateTypeForfait({ commit, state }) {
    await postTypeForfaitTransport(state.typeForfaitTransport.typeForfait)
  },
  async resetForfaitTransport({ commit }) {
    await resetForfaitTransport()
  },
  openForfaitTypeModal({ dispatch }) {
    dispatch('openModal', { type: constants.FORFAIT_TYPE_MODIFICATION_MODAL })
  },
  openForfaitResetModal({ dispatch }) {
    dispatch('openModal', { type: constants.FORFAIT_RESET_MODAL })
  }
}

const getters = {
  typeForfaitTransport: state => state.typeForfaitTransport
}

export default { state, mutations, actions, getters }
